import type { ISelectOption } from '../../../../../utils/types';
import type { DischargeCriteriaFieldConfig, DischargeCriteriaFormValues } from './types';

export const DISCHARGE_CRITERIA_FIELDS: ReadonlyArray<DischargeCriteriaFieldConfig> = [
  {
    name: 'mastery_of_program_goals',
    label: "Client's and family's ability to master the program",
    placeholder: "Client's and family's ability to master the program/goals",
  },
  {
    name: 'titration_plan',
    label: 'Titration plan',
    placeholder: 'How and when to step down in program hours',
  },
  {
    name: 'readiness_to_step_down',
    label: "Client's readiness to step down",
    placeholder: "Client's readiness to move from the current level of service",
  },
  {
    name: 'care_coordination',
    label: 'Care coordination',
    placeholder: 'Communication between clinicians and other professionals',
  },
];

export const EMPTY_DISCHARGE_CRITERIA_VALUES: DischargeCriteriaFormValues = {
  mastery_of_program_goals: '',
  titration_plan: '',
  readiness_to_step_down: '',
  care_coordination: '',
};

export const DISCHARGE_RICH_TEXT_MIN_VISIBLE_CHARACTERS = 60;

export const DISCHARGE_RICH_TEXT_MAX_LENGTH = 50000;

export const DISCHARGE_REASON_OTHER = 'Other';

export const DISCHARGE_OTHER_EXPLANATION_MIN_LENGTH = 4;

export const DISCHARGE_REASON_OPTIONS: ReadonlyArray<ISelectOption> = [
  {
    value: 'The client has mastered all treatment goals, and no new goals are identified',
    label: 'The client has mastered all treatment goals, and no new goals are identified',
  },
  {
    value: 'All maladaptive behavior goals have been mastered and generalized',
    label: 'All maladaptive behavior goals have been mastered and generalized',
  },
  {
    value: 'No new behaviors have emerged',
    label: 'No new behaviors have emerged',
  },
  {
    value: 'Client’s Vineland-3 scores have reached a level in accordance with similar-aged peers',
    label: 'Client’s Vineland-3 scores have reached a level in accordance with similar-aged peers',
  },
  {
    value: 'Client’s AFLS scores have reached a level in accordance with similar-aged peers',
    label: 'Client’s AFLS scores have reached a level in accordance with similar-aged peers',
  },
  {
    value:
      'Client’s parents/caregivers report confidence in continuing ABA intervention techniques',
    label:
      'Client’s parents/caregivers report confidence in continuing ABA intervention techniques',
  },
  {
    value: 'Client no longer able to participate due to medical reasons',
    label: 'Client no longer able to participate due to medical reasons',
  },
  {
    value: 'Parents prefer a new provider',
    label: 'Parents prefer a new provider',
  },
  {
    value: 'Client no longer able to participate due to personal changes',
    label: 'Client no longer able to participate due to personal changes',
  },
  {
    value: 'No progress has been made for 3 months',
    label: 'No progress has been made for 3 months',
  },
  {
    value: 'Goals are not maintaining or generalizing',
    label: 'Goals are not maintaining or generalizing',
  },
  {
    value: 'Other',
    label: 'Other',
  },
];

export const DISCHARGE_REASON_DELETE_ICON_SIZE = 40;
